import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class NameSuffixService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/suffixes`, options);
  }
}

export default NameSuffixService;
